import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export const HelmetHelper = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>
          {t('companySingleName')} - {t('productShortName')}
        </title>
      </Helmet>
      <Helmet>
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-57x57.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-60x60.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-72x72.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-76x76.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-114x114.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-120x120.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-144x144.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-152x152.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/apple-icon-180x180.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/android-icon-192x192.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/favicon-32x32.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/favicon-96x96.png`} />
        <link rel="icon" type="image/png" sizes="16x16" href={`${process.env.PUBLIC_URL}/figure-favicons/favicon-16x16.png`} />
      </Helmet>
    </>
  );
};
